import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import {
  ConfigProvider,
  Col,
  Row,
  AutoComplete,
  Tooltip,
  List,
  Typography,
} from "antd";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";

import { useDispatch, useSelector } from "react-redux";
import {
  setTextSearch,
  setSearchBarPosition,
} from "../../../../../redux/features/main/searchSlice";

import { setLocalStorage, getLocalStorage } from "../../../../../utils";
import { useTranslation } from "react-i18next";

const SearchMobileLearningJourney = () => {
  const isCollectionCL = useSelector((state) => state.search.isCollectionCL);
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();
  const { Option } = AutoComplete;

  const [itemsSearchBar, setItemsSearchBar] = useState([]);

  const [searchBarPage, setSearchBarPage] = useState("");
  const [isOpenTooltipToolbar, setIsOpenTooltipToolbar] = useState(false);
  const [tooltipMessage, setTooltipMessage] = useState("");
  const [isOpenSelect, setIsOpenSelect] = useState(false);
  const [valueSearch, setValueSearch] = useState("");
  let [searchParams, setSearchParams] = useSearchParams();

  const location = useLocation();
  const locPathname = location.pathname;

  const handleSelectSearchBar = (value) => {
    // console.log(`selected ${value}`);

    setIsOpenSelect(false);

    dispatch(setTextSearch(value));
    setSearchParams({ search: value });
    dispatch(setSearchBarPosition(searchBarPage));

    // local Storage things to save, read, and set
    const historyValue =
      Array.isArray(getLocalStorage(searchBarPage)) === true
        ? getLocalStorage(searchBarPage)
        : JSON.parse(getLocalStorage(searchBarPage));

    const arrayHistory = historyValue,
      index = arrayHistory.findIndex((v) => v === value);

    if (index !== -1) arrayHistory.unshift(...arrayHistory.splice(index, 1));

    // trim array to only 5 history
    const trimArr =
      arrayHistory.length > 5 ? arrayHistory.slice(0, 5) : arrayHistory;

    setLocalStorage(searchBarPage, JSON.stringify(trimArr));

    setValueSearch(value);
  };

  const deleteOption = (value) => {
    setItemsSearchBar(
      itemsSearchBar.filter((item) => {
        return item.value !== value;
      }),
    );
    let historySearchToDelete =
      Array.isArray(getLocalStorage(searchBarPage)) === true
        ? getLocalStorage(searchBarPage)
        : JSON.parse(getLocalStorage(searchBarPage));

    historySearchToDelete = historySearchToDelete.filter((e) => e !== value);

    setLocalStorage(searchBarPage, JSON.stringify(historySearchToDelete));

    // console.log("deleted", value);
  };

  const handleOnSearch = (value) => {
    if ((value.length < 3 && value.length !== 0) || value.length >= 50) {
      setIsOpenTooltipToolbar(true);
      if (value.length < 3 && value.length !== 0) {
        setTooltipMessage(t("feature.feature_search.please_enter"));
      } else {
        setTooltipMessage(t("feature.feature_search.limit_char_reach"));
      }
    } else {
      setIsOpenTooltipToolbar(false);
    }
    setValueSearch(value);
  };

  const handleEnter = (value) => {
    // keyCode for button Enter
    if (value.keyCode === 13) {
      if (valueSearch.length >= 3) {
        // console.log("Enter !!");

        setIsOpenSelect(false);

        dispatch(setTextSearch(valueSearch));
        setSearchParams({ search: valueSearch });
        dispatch(setSearchBarPosition(searchBarPage));

        // local Storage things to save, read, and set
        const historySearchMylj =
          Array.isArray(getLocalStorage(searchBarPage)) === true
            ? getLocalStorage(searchBarPage)
            : JSON.parse(getLocalStorage(searchBarPage));

        if (historySearchMylj.indexOf(valueSearch) === -1) {
          historySearchMylj.unshift(valueSearch);
        }

        // trim array to only 5 history
        const trimArr =
          historySearchMylj.length > 5
            ? historySearchMylj.slice(0, 5)
            : historySearchMylj;

        setLocalStorage(searchBarPage, JSON.stringify(trimArr));
        if (itemsSearchBar.length === 0) setItemsSearchBar([...trimArr]);
      }
    }
  };

  const handleFocus = () => {
    if (itemsSearchBar.length > 0) {
      setIsOpenSelect(true);
      settingItemsSearch(getLocalStorage(searchBarPage));
    } else {
      setIsOpenSelect(false);
    }
  };

  const settingItemsSearch = (dataLocalStorage) => {
    const arryLocalStore =
      Array.isArray(dataLocalStorage) === true
        ? dataLocalStorage
        : JSON.parse(dataLocalStorage);

    const dataItemsSearch = [].concat(
      ...arryLocalStore.map((item, index) => {
        return {
          key: parseInt(index + 1),
          id: parseInt(index + 1),
          value: item,
          label: item,
        };
      }),
    );

    // console.log(dataItemsSearch)
    setItemsSearchBar([...dataItemsSearch]);
  };

  useEffect(() => {
    if (searchBarPage !== "")
      settingItemsSearch(getLocalStorage(searchBarPage));
  }, [searchBarPage]);

  useEffect(() => {
    const arrloc = locPathname.split("/");
    if (
      (arrloc.length === 2 && arrloc.indexOf("my-learning-journey") > -1) ||
      locPathname.indexOf("my-learning-journey/search") > -1
    ) {
      setSearchBarPage("search_mylj");
      dispatch(setSearchBarPosition("search_mylj"));
    } else if (
      (arrloc.length === 2 && arrloc.indexOf("content-library") > -1) ||
      locPathname.indexOf("content-library/search") > -1
    ) {
      if (isCollectionCL === false) {
        setSearchBarPage("search_cl");
        dispatch(setSearchBarPosition("search_cl"));
      } else {
        setSearchBarPage("");
        dispatch(setSearchBarPosition(""));
        setIsOpenTooltipToolbar(false);
      }
    } else {
      setSearchBarPage("");
      dispatch(setSearchBarPosition(""));
      setIsOpenTooltipToolbar(false);
    }
    // console.log(arrloc)
  }, [location, isCollectionCL]);

  const queryParams = new URLSearchParams(location.search);
  const searchQuery = queryParams.get("search");

  useEffect(() => {
    if (searchQuery) {
      setValueSearch(searchQuery);
    }
  }, [searchQuery]);

  useEffect(() => {
    const updateDropdownMargin = () => {
      const elements = document.getElementsByClassName(
        "wrapper-content-items-search",
      );
      if (elements.length > 0) {
        const parentElement = elements[0].closest(".ant-select-dropdown");
        if (parentElement) {
          parentElement.style.marginTop = isOpenTooltipToolbar
            ? "11%"
            : "unset";
        }
      }
    };

    updateDropdownMargin();
  }, [isOpenTooltipToolbar]);

  return (
    <Row
      align={"middle"}
      style={{
        height: "auto",
        marginBottom: 10,
        width: "100%",
      }}
    >
      <Col span={24}>
        <div
          className="search-bar"
          style={{ display: "flex", alignItems: "center" }}
        >
          <Tooltip
            placement="bottomLeft"
            title={tooltipMessage}
            open={isOpenTooltipToolbar}
            arrow
            align={{ offset: [15, 10] }}
            getPopupContainer={(trigger) => {
              return trigger;
            }}
          >
            <AutoComplete
              // optionLabelProp="value"
              className="search-bar-autocomplete-mobile"
              showSearch
              size="middle"
              placeholder={t("feature.feature_search.what_do_you")}
              allowClear={<CloseOutlined />}
              suffixIcon={<SearchOutlined style={{ fontSize: 14 }} />}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onSelect={handleSelectSearchBar}
              onSearch={handleOnSearch}
              onKeyDown={handleEnter}
              onFocus={handleFocus}
              onBlur={() => setIsOpenSelect(true)}
              searchValue={valueSearch}
              autoClearSearchValue={false}
              filterOption={false}
              maxLength={50}
              open={isOpenSelect}
              value={valueSearch}
              autoFocus={false}
            >
              {itemsSearchBar !== undefined &&
                itemsSearchBar.map((task, index) => {
                  return (
                    <Option
                      key={index}
                      value={task.value}
                      label={task.label}
                      className="wrapper-content-items-search"
                    >
                      <span>{task.label}</span>
                      <span style={{ float: "right" }}>
                        <CloseOutlined
                          style={{
                            width: 8,
                            height: 8,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteOption(task.value);
                          }}
                        />
                      </span>
                    </Option>
                  );
                })}
            </AutoComplete>
          </Tooltip>
        </div>
      </Col>
    </Row>
  );
};

export default SearchMobileLearningJourney;
